module.exports = __webpack_public_path__ + "c842480b1171c5975b9f956c5b63ca0a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/sm_image_2_0.png
// module id = 514
// module chunks = 0